module.exports = __webpack_public_path__ + "img/notification-bell-desktop-ru.4789f8a2.jpg";